import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import BlurImage from "@/components/BlurImage";
import { MapPin, Clock, ArrowRight } from "lucide-react";
import shadwell from "@/assets/shadwell-great-house.jpg";

const PlacePresence = () => {
  return (
    <section
      aria-labelledby="place-presence"
      className="relative overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, hsl(40 35% 92%) 0%, hsl(40 30% 95%) 100%)",
      }}
    >
      <div className="container mx-auto px-6 pt-20 pb-2 md:pt-28 md:pb-4" style={{ maxWidth: "1400px" }}>
        <div className="grid lg:grid-cols-[1.1fr_1fr] gap-12 lg:gap-20 items-center">
          {/* Image with gold frame */}
          <Reveal className="relative order-2 lg:order-1">
            <div className="relative aspect-[4/5] overflow-hidden rounded-sm shadow-[0_40px_80px_-30px_rgba(0,0,0,0.4)] bg-[hsl(35_25%_82%)]">
              <BlurImage
                src={shadwell}
                alt="Shadwell Great House — the physical home of Sugar Town Organics"
                wrapperClassName="absolute inset-0 w-full h-full"
                sizes="(min-width: 1024px) 55vw, 100vw"
                placeholderColor="hsl(35 25% 82%)"
              />

              <div
                aria-hidden
                className="absolute inset-0 bg-gradient-to-tr from-[hsl(150_35%_8%)]/25 via-transparent to-transparent"
              />
              <div className="absolute bottom-6 left-6 right-6 flex items-center gap-3 text-[hsl(40_33%_96%)]">
                <MapPin className="w-4 h-4 text-accent" />
                <p className="font-sans text-[11px] tracking-[0.28em] uppercase">
                  Shadwell Estate · St. Kitts
                </p>
              </div>
            </div>
            <div
              aria-hidden
              className="hidden lg:block absolute -inset-4 border border-accent/40 rounded-sm -z-10"
            />
            <div
              aria-hidden
              className="hidden lg:block absolute -bottom-6 -right-6 w-32 h-32 border border-accent/30"
            />
          </Reveal>

          {/* Copy */}
          <Reveal className="order-1 lg:order-2" delay={120}>
            <p className="font-sans text-[11px] tracking-[0.42em] uppercase text-accent mb-5">
              The Physical Home
            </p>
            <h2 id="place-presence" className="font-serif text-4xl md:text-5xl text-foreground leading-[1.05] mb-6">
              Where the Ecosystem Lives
            </h2>
            <p className="font-sans text-base md:text-lg text-foreground/75 leading-relaxed mb-5">
              Tucked inside the historic{" "}
              <span className="font-medium text-foreground">Shadwell Great House</span>,
              <span className="font-medium text-foreground"> Di Organics Shoppe</span> is
              where Sugar Town Organics botanicals, Flauriel island treats,
              curated gift boxes and heritage keepsakes come to life in person.
            </p>
            <p className="font-serif italic text-foreground/70 text-lg mb-8">
              An old estate. The scent of lemongrass. Shelves of island-made
              things worth taking home.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-6">
              <Link
                to="/visit-di-organics-shoppe"
                className="inline-flex items-center justify-center gap-2 bg-accent text-accent-foreground px-7 py-3.5 rounded-sm font-sans font-semibold text-[11px] uppercase tracking-[0.28em] hover:opacity-90 transition-opacity shadow-[0_8px_24px_-12px_hsl(var(--accent)/0.6)]"
              >
                <MapPin className="w-4 h-4" /> Plan Your Visit
              </Link>
              <a
                href="https://www.google.com/search?q=di+organics+shoppe"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 border border-foreground/25 text-foreground px-7 py-3.5 rounded-sm font-sans font-semibold text-[11px] uppercase tracking-[0.28em] hover:border-accent hover:text-accent transition-colors"
              >
                Get Directions <ArrowRight className="w-4 h-4" />
              </a>
            </div>

            <p className="font-sans text-xs text-muted-foreground tracking-wide flex items-center gap-2">
              <Clock className="w-3.5 h-3.5 text-accent" />
              Open Monday – Saturday · 10am – 5pm · Free parking on estate
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default PlacePresence;
